var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef } from 'react';
import { findDOMNode } from 'react-dom';
import styled from 'styled-components';
import ReactPlayer from 'react-player';
import { PlayerButton } from '../../svgs/PlayButton';
import { useWindowSize } from '../../hooks/useWindowSize';
import screenFull from 'screenfull';
import { LoaderBars } from '../../components';
export function VideoPlayer(props) {
    var player = useRef();
    var source = props.source, setEnded = props.setEnded;
    var windowSize = useWindowSize();
    var _a = useState({
        url: source,
        ready: false,
        playing: false,
        buffering: false,
        volume: 1,
        muted: false,
        played: 0,
        loaded: 0,
        duration: 0,
        playbackRate: 1
    }), state = _a[0], setVState = _a[1];
    function setState(updates) {
        setVState(function (s) { return (__assign(__assign({}, s), updates)); });
    }
    //   function load(url: string) {
    //     setState({
    //       url,
    //       played: 0,
    //       loaded: 0,
    //       pip: false
    //     })
    //   }
    function handlePlayPause() {
        if (state.playing) {
            handlePause();
        }
        else {
            handlePlay();
        }
        setState({ playing: !state.playing });
    }
    function handleReady() {
        // console.log('ran ready')
        setState({ ready: true });
    }
    function handleStart() {
        // console.log('ran start')
        handlePlay();
    }
    function handleStop() {
        // console.log('ran stop')
        setState({ playing: false });
    }
    function handleVolumeChange(e) {
        // console.log('ran volume change')
        setState({ volume: parseFloat(e.target.value) });
    }
    function handleToggleMuted() {
        // console.log('ran muted')
        setState({ muted: !state.muted });
    }
    function handlePlay() {
        // console.log('handle play')
        setState({ playing: true });
        if (screenFull.isEnabled && windowSize.width && windowSize.width < 700) {
            var el = findDOMNode(player.current);
            if (el instanceof Element) {
                screenFull.request(el).catch(function (error) {
                    console.log(error);
                });
            }
        }
    }
    function handlePause() {
        // console.log('ran pause')
        setState({ playing: false });
        if (screenFull.isEnabled) {
            screenFull.exit();
        }
    }
    function handleBufferStart() {
        setState({ buffering: true });
    }
    function handleBufferEnd() {
        setState({ buffering: false });
    }
    function handleProgress(state) {
        // console.log('ran progress')
        if (!state.seeking) {
            setState(state);
        }
    }
    function handleEnded() {
        // console.log('ran ended')
        setState({ playing: false });
        setEnded();
    }
    function handleDuration(duration) {
        // console.log('duration')
        setState({ duration: duration });
    }
    var url = state.url, playing = state.playing, volume = state.volume, muted = state.muted, playbackRate = state.playbackRate, ready = state.ready, buffering = state.buffering;
    function handleGlobalClick(event) {
        console.log('global click');
        if (ready) {
            handlePlayPause();
        }
    }
    return (_jsxs(StyledPlayer, __assign({ onClick: handleGlobalClick }, { children: [_jsx(ReactPlayer, { ref: player, className: 'react-player', width: '100%', height: '100%', url: url, playing: playing, 
                // light
                playbackRate: playbackRate, volume: volume, muted: muted, onReady: handleReady, onStart: handleStart, onPlay: handlePlay, onBuffer: handleBufferStart, onBufferEnd: handleBufferEnd, onPause: handlePause, onEnded: handleEnded, onError: function (e) { return console.log('onError', e); }, onProgress: handleProgress, onDuration: handleDuration, 
                // playsinline
                // playIcon={() => <PlayerButton className='player-play' />}
                config: {
                    file: {
                        attributes: {
                            disablePictureInPicture: true
                        }
                    }
                } }, void 0),
            !ready || buffering ? (_jsx(LoaderBars, { className: 'player-play' }, void 0)) : !playing ? (_jsx(PlayerButton, { className: 'player-play' }, void 0)) : null] }), void 0));
}
var StyledPlayer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  padding-top: 56.25%;\n  position: relative;\n  /* background: gray; */\n  .react-player {\n    position: absolute;\n    top: 0;\n    right: 0;\n  }\n  .react-player__play-icon {\n    color: red;\n    fill: red;\n  }\n  .player-play {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 10%;\n    max-width: 50px;\n    cursor: pointer;\n    transition: 0.5s;\n    &:hover {\n      circle {\n        fill: darkred;\n      }\n    }\n  }\n"], ["\n  width: 100%;\n  padding-top: 56.25%;\n  position: relative;\n  /* background: gray; */\n  .react-player {\n    position: absolute;\n    top: 0;\n    right: 0;\n  }\n  .react-player__play-icon {\n    color: red;\n    fill: red;\n  }\n  .player-play {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 10%;\n    max-width: 50px;\n    cursor: pointer;\n    transition: 0.5s;\n    &:hover {\n      circle {\n        fill: darkred;\n      }\n    }\n  }\n"])));
var templateObject_1;
